import { Image, Text, View } from '@react-pdf/renderer'
import { useFormatNumber } from '../../../../hooks/useFormatNumber';
import { blankFooterStyles } from '../blankFooter/blankFooterStyles';
import { footerInLastPageStyles } from './footerInLastPageStyles';
import { defaultTheme } from '../../../../theme/theme';

export const FooterInLastPage = ({ data, showTranslatedText }: any) => {

    let primaryColor = defaultTheme.palette.primary.main

    const {  bankAccountsData, notes, totals, weights } = footerInLastPageStyles();

    const { blankFooter } = blankFooterStyles();

    const { setFormatNumber } = useFormatNumber();

    return (
        <View >
            
            {/* Cuentas de banco */}
            <View style={bankAccountsData.container} >
                <View style={[bankAccountsData.instructionsContainer, { backgroundColor: primaryColor }]}>
                    <Text style={[bankAccountsData.instructionsText, { color: 'white' }]}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.pleaseMakePaymentToTheFollowingAccounts")}</Text>
                </View>
                <View style={bankAccountsData.bankAccountsContainer}>
                    <View style={bankAccountsData.bankAccountContainerFirstAccount}>
                        <Text style={bankAccountsData.bankAccountTitle}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.firstAccount")}</Text>
                        <View style={bankAccountsData.bankAccountDataContainer}>
                            <View style={bankAccountsData.bankAccountData}>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.accountAlias")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_primary_account_alias || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.interbankKey")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_primary_interbank_key || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>Swift</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_primary_swift_code || ' '}</Text>
                                </View>
                            </View>
                            <View style={bankAccountsData.bankAccountData}>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.bankName")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_primary_bank_name || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.account")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_primary_account_number || ' '}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                    <View style={bankAccountsData.bankAccountContainerSecondAccount}>
                        <Text style={bankAccountsData.bankAccountTitle}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.secondaryAccount")}</Text>
                        <View style={bankAccountsData.bankAccountDataContainer}>
                            <View style={bankAccountsData.bankAccountData}>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.accountAlias")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_secondary_account_alias || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.interbankKey")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_secondary_interbank_key || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>Swift</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_secondary_swift_code || ' '}</Text>
                                </View>
                            </View>
                            <View style={bankAccountsData.bankAccountData}>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.bankName")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_secondary_bank_name || ' '}</Text>
                                </View>
                                <View style={bankAccountsData.bankAccountField}>
                                    <Text style={bankAccountsData.bankAccountConcept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.account")}</Text>
                                    <Text style={bankAccountsData.bankAccountText}>{data.dataInvoiceGeneral.company_secondary_account_number || ' '}</Text>
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            </View>

            {/* Datos del sat */}
            <View style={{ marginTop: 2, height: 110, flexDirection: 'row' }}>
                <View style={{ flex: 1, alignItems: 'center' }}>
                    <Image style={{ width: 110, height: 110 }} src={data.dataInvoiceGeneral.fiscalQr ? data.dataInvoiceGeneral.fiscalQr : ' '} />
                </View>
                <View style={{ flex: 3, justifyContent: 'space-around' }}>
                    <View style={{ borderWidth: 1, height: 40 }}>
                        <View style={{ borderBottomWidth: 1, alignItems: 'center', backgroundColor: primaryColor}}>
                            <Text style={{ fontSize: 6, fontWeight: 700, color: 'white' }} >{showTranslatedText("reports.salesInvoicePdf.satData.digitalStamp")}:</Text>
                        </View>
                        <View style={{ alignItems: 'center', paddingHorizontal: 5, justifyContent: 'center' }}>
                            <Text style={{ fontSize: 5 }}> {data.dataInvoiceGeneral.seal_CFDI || ' '}</Text>
                        </View>
                    </View>
                    <View style={{ borderWidth: 1, height: 50 }}>
                        <View style={{ borderBottomWidth: 1, alignItems: 'center', backgroundColor: primaryColor }}>
                            <Text style={{ fontSize: 6, fontWeight: 700, color: 'white' }}>{showTranslatedText("reports.salesInvoicePdf.satData.digitalCertification")}:</Text>
                        </View>
                        <View style={{ alignItems: 'center', paddingHorizontal: 5, justifyContent: 'center' }}>
                            <Text style={{ fontSize: 5 }}> {data.dataInvoiceGeneral.original_string_SAT || ' '}</Text>
                        </View>
                    </View>
                </View>
            </View>

            {/* Pie de pagina en ultima pagina */}
            <View style={{
                height: 80,
                borderWidth: 1,
                flexDirection: 'row',
                marginTop: 2
            }} >
                <View style={notes.container}>
                    <Text style={{ fontWeight: 700, fontSize: 6 }}>{showTranslatedText("reports.salesInvoicePdf.footer.notes")}:</Text>
                    <Text style={{ fontSize: 6 }}>{data.dataInvoiceGeneral.notes}</Text>
                </View>
                <View style={weights.container}>
                    <Text style={{ fontSize: 6 }}>{showTranslatedText("reports.salesInvoicePdf.footer.weights")}:</Text>
                    <br />
                    <View style={weights.weights} >
                        <Text style={{ fontWeight: 700, fontSize: 6 }}>{showTranslatedText("reports.salesInvoicePdf.footer.grossWeight")}: ({data.dataTransportationDocument?.weight_unit || ' '})</Text>
                        <Text style={{ fontSize: 6 }}>{data.dataShippingTracking.gross_weight || ' '}</Text>
                    </View>
                    <View style={weights.weights}>
                        <Text style={{ fontWeight: 700, fontSize: 6 }}>{showTranslatedText("reports.salesInvoicePdf.footer.netWeight")}:</Text>
                        <Text style={{ fontSize: 6 }}>{data.dataShippingTracking.net_weight || ' '}</Text>
                    </View>
                </View>
                <View style={totals.container}>
                    <View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.taxes")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataInvoiceGeneral.tax_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.retentions")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataInvoiceGeneral.retention_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.discounts")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataInvoiceGeneral.discount_amount || 0 }) || ' '}</Text>
                        </View>
                    </View>
                    <View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.subtotal")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataInvoiceGeneral.subtotal_amount || 0 }) || ' '}</Text>
                        </View>
                        <View style={totals.totalField}>
                            <Text style={blankFooter.concept}>{showTranslatedText("reports.salesInvoicePdf.lastPageFooter.total")}:</Text>
                            <Text style={blankFooter.text}>{setFormatNumber({ value: data.dataInvoiceGeneral.total_amount || 0 }) || ' '}</Text>
                        </View>
                    </View>
                </View>
            </View>
        </View>

    )
}
